import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-catalogs',
  templateUrl: './catalogs.component.html',
  styleUrls: ['./catalogs.component.sass']
})
export class CatalogsComponent implements OnInit {
  catalogsListSubs: Subscription;
  catalogs: any;
  catalogueForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = true;
  modification_date: string;
  creation_date: string;
  logo_url: string;
  pageSize: number = 100;
  pageIndex: number = 0;

  duplicate: boolean = false

  showCatalogsProgressBar: boolean = true;

  displayedColumns: string[] = ['name', 'description', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;


  // For products grid
  showProductsGrid: boolean = false;

  productsList: any;
  selectedProductsListColumns: string[] = ['name', 'value', 'highlighted','highlighted_reportage','min', 'max' ,'downloadable', 'actions']
  selectedProductsList: any[] = [];
  productDescriptionList: any = [];
  showProductListLoadingSpinner: boolean = true;

  productValueForm: FormGroup;
  editValueState: any = { id: '' }

  defaultPriceList: any = []
  showCatalogProductsTableBar: boolean = false;


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar
  ) {

    if (this.route.snapshot.routeConfig.path.includes('duplicate'))
    {
      this.duplicate = true
    }

    this.productValueForm = this.formBuilder.group({

      value: new FormControl('', Validators.required)

    })

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(localStorage.getItem('catalogs'))
    {
      let data = JSON.parse(localStorage.getItem('catalogs'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1
    }
  }


  ngOnInit() {
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.catalogueForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      min: new FormControl(0, Validators.required),
      max: new FormControl(0, Validators.required),

      description: new FormControl('', Validators.required),
      value_shipping: new FormControl(null),
      shipping_tax: new FormControl(21),
      no_shipping: new FormControl(true),
      no_shipping_txt: new FormControl(''),
      no_shipping_txt_cat: new FormControl(''),
      no_shipping_txt_en: new FormControl(''),
    });


    // this.catalogs = this.getCatalogs();
    // this.routeSub =



    this.route.params.subscribe(params => {
      this.dataService.getCatalogs().subscribe(catalogs => {
        this.catalogs = catalogs;
        this.dataSource.data = this.catalogs;
        this.showCatalogsProgressBar = false
      });
      if (params.id) {
        this.isList = false;
        if (params.id != 'new') {
          this.showCatalogProductsTableBar = true;
          this.isNew = false;
          this.catalogsListSubs = this.dataService
            .getCatalogue(params.id) //cambiar por id en el html
            .subscribe(res => {
              this.catalogs = res;

              if(!this.route.toString().includes('duplicate')) 
              {
                this.catalogueForm.controls["id"].setValue(this.catalogs.id);
                this.catalogueForm.controls["name"].setValue(this.catalogs.name);
              }
              // this.catalogueForm.controls["min"].setValue(this.catalogs.min);
              // this.catalogueForm.controls["max"].setValue(this.catalogs.max);
              this.catalogueForm.controls["description"].setValue(this.catalogs.description);
              this.catalogueForm.controls["value_shipping"].setValue(this.catalogs.value_shipping);
              this.catalogueForm.controls["shipping_tax"].setValue(this.catalogs.shipping_tax);
              this.catalogueForm.controls["no_shipping"].setValue(this.catalogs.no_shipping);
              this.catalogueForm.controls["no_shipping_txt"].setValue(this.catalogs.no_shipping_txt);
              this.catalogueForm.controls["no_shipping_txt_cat"].setValue(this.catalogs.no_shipping_txt_cat);
              this.catalogueForm.controls["no_shipping_txt_en"].setValue(this.catalogs.no_shipping_txt_en);

              this.creation_date = this.catalogs.creation_date;
              this.modification_date = this.catalogs.modification_date;



              // Saves specific params here (if: highlighted, downloadable, etc.)
              let prodGrid = res['products_grid']

              // Saves only valuable info in easily accesible format (ex. [id : {params: values}, ...] )
              let productParams = {}

              prodGrid.forEach(element => {
                productParams[element.product._flat_path[1]] = { value: element.value, highlighted: element.highlighted, min: element.min, max: element.max, downloadable: element.downloadable, highlighted_reportage: element.highlighted_reportage ,priority: element.priority }
              });


              // Retrieve all products for grid
              this.dataService.getProducts('photo').subscribe(res => {
                this.productsList = res

                let downloadedSelectedProductList = []

                this.showProductListLoadingSpinner = false

                // For each DEFAULT product:
                this.productsList.forEach(product => {
                  // Save the DEFAULT value of said product
                  this.defaultPriceList.push({ id: product.id, value: product.value })

                  // If the current product's id matches an existing one from the selected products:
                  if (productParams[product.id]) {

                    // Update the following params so they match the configuration for this catalog
                    product['priority'] = productParams[product.id].priority
                    product['value'] = productParams[product.id].value;
                    product['min'] = productParams[product.id].min;
                    product['max'] = productParams[product.id].max;
                    product['highlighted'] = productParams[product.id].highlighted;
                    product['highlighted_reportage'] = productParams[product.id].highlighted_reportage;
                    product['downloadable'] = productParams[product.id].downloadable;
                    product['selected'] = true;

                    // Add this item to the temporary array of selected products from DB.
                    downloadedSelectedProductList.push(product)


                  } else {

                    // Else, asign default temporary values;
                    product['min'] = 0;
                    product['max'] = 0;
                    product['highlighted'] = false;
                    product['highlighted_reportage'] = false;
                    product['downloadable'] = false;

                  }

                  // Prep description variable so it can be displayed properly
                  let description = JSON.parse(product.description);

                  this.productDescriptionList[product.id] = description;

                });

                // Asign content to the data source of the products table
                this.selectedProductsList = downloadedSelectedProductList;

                // Sort the items so they match previously selected priority
                this.selectedProductsList.sort((a, b) => (parseInt(a.priority) > parseInt(b.priority)) ? 1 : -1);

                this.showCatalogProductsTableBar = false;
              })


            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
      }
    });

  }

  // Method for Drag and drop feature list update
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedProductsList, event.previousIndex, event.currentIndex);

    this.selectedProductsList = [...this.selectedProductsList];
  }

  goTo(catalogueID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('catalogs', JSON.stringify(data))
    this.router.navigateByUrl(`catalogue/${catalogueID}`);
  }

  applyFilter(text: any) {
    const filterValue = (text.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newCatalogue() {
    this.router.navigateByUrl(`catalogue/new`);
  }

  goDuplicateCatalogue(catalogueID: string) {
    this.router.navigateByUrl(`catalogue/${catalogueID}/duplicate`);
  }

  saveCatalogue() {

    var params = {};
    params['name'] = this.catalogueForm.controls["name"].value;
    params['id'] = this.catalogueForm.controls["id"].value;
    params['description'] = this.catalogueForm.controls["description"].value;
    params['value_shipping'] = this.catalogueForm.controls["value_shipping"].value;
    params['shipping_tax'] = this.catalogueForm.controls["shipping_tax"].value;
    params['no_shipping'] = this.catalogueForm.controls["no_shipping"].value;
    params['no_shipping_txt'] = this.catalogueForm.controls["no_shipping_txt"].value;
    params['no_shipping_txt_cat'] = this.catalogueForm.controls["no_shipping_txt_cat"].value;
    params['no_shipping_txt_en'] = this.catalogueForm.controls["no_shipping_txt_en"].value;


    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
;

    this.dataService.saveCatalogue(params).subscribe(data => {
      console.warn(data)
      if (data.status == 'success') {
        this.router.navigateByUrl(`catalogs`);
      }
      else {
        this.translate.get('alerts.save_catalog_error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })
  }

  duplicateCatalogue() {

    var params = {};
    params['name'] = this.catalogueForm.controls["name"].value;
    params['id'] = this.catalogueForm.controls["id"].value;
    params['description'] = this.catalogueForm.controls["description"].value;
    params['value_shipping'] = this.catalogueForm.controls["value_shipping"].value;
    params['shipping_tax'] = this.catalogueForm.controls["shipping_tax"].value;
    params['no_shipping'] = this.catalogueForm.controls["no_shipping"].value;
    params['no_shipping_txt'] = this.catalogueForm.controls["no_shipping_txt"].value;
    params['no_shipping_txt_cat'] = this.catalogueForm.controls["no_shipping_txt_cat"].value;
    params['no_shipping_txt_en'] = this.catalogueForm.controls["no_shipping_txt_en"].value;


    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
;

    this.dataService.saveCatalogue(params).subscribe(data => {
      console.warn(data)
      if (data.status == 'success') {
        this.saveProductGrid(this.catalogueForm, data.context)
      }
      else {
        this.translate.get('alerts.save_catalog_error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })
  }

  saveProductGrid(form: FormGroup, id: any = undefined) {
    let params = {}
    // TODO add to params catalogueID, array of selected product id [product_ID] (vemos lo que tienes y lo adaptamos)

    let products = []
    let earlyExit = {"status": false, "error": ""};

    this.selectedProductsList.forEach(element => {

      if (Number(element.min) > Number(element.max)){
        earlyExit['status'] = true
        earlyExit['error'] = "min_is_bigger"
      }
      if (element.highlighted_reportage && element.min == 0){
        earlyExit['status'] = true
        earlyExit['error'] = "min_is_zero"
      }

      let product = {
        id: element.id,
        value: element.value,
        min: element.min,
        max: element.max,
        highlighted: element.highlighted,
        highlighted_reportage: element.highlighted_reportage,
        downloadable: element.downloadable,
        priority: this.selectedProductsList.indexOf(element)
      }

      products.push(product)

    })

    if (earlyExit.status){
      // alert("early exit " + earlyExit.error)
      this.translate.get('alerts.'+earlyExit.error).subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return;
    }


    params['products_grid'] = JSON.stringify(products);
    params['catalogue_name'] = form.value.name;
    params['catalogue_description'] = form.value.description;
    params['value_shipping'] = form.value.value_shipping;
    params['shipping_tax'] = form.value.shipping_tax;
    params['no_shipping'] = form.value.no_shipping;
    params['no_shipping_txt'] = form.value.no_shipping_txt;
    params['no_shipping_txt_cat'] = form.value.no_shipping_txt_cat;
    params['no_shipping_txt_en'] = form.value.no_shipping_txt_en;


    this.route.params.subscribe(res => {
      params['catalogueID'] = id? id : res.id
      
      this.dataService.updateRelatedProduct(params).subscribe(res => {
        // this.showProductsGrid = !this.showProductsGrid

        if (res.status == 'ok') {
          this.router.navigateByUrl(`catalogs`);
        }
        else {
          this.translate.get('alerts.update_related_product_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }

      })
    })

  }


  productSelectHandler(item: any) {

    let newSelectedProductsList = this.selectedProductsList;


    if (item.selected) {

      this.productsList.forEach(element => {

        if (item.id == element.id) {

          delete element['selected']

          newSelectedProductsList = newSelectedProductsList.filter(item => item !== element)

        }

      });

    } else {

      this.productsList.forEach(element => {

        if (item.id == element.id) {

          element['selected'] = true;

          if (element.gift_list && element.gift_list != '') {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.has_gift'), duration: 4000, panelClass: "error-snackbar" })
          }

          newSelectedProductsList.push(element);
          newSelectedProductsList[newSelectedProductsList.indexOf(element)].priority = newSelectedProductsList.indexOf(element)

        }

      });

    }


    // this.productsList.forEach(element => {

    //   if (element.selected) {

    //     newSelectedProductsList.push(element)

    //   }

    // });



    this.selectedProductsList = newSelectedProductsList
  }


  tableButtonHandler(id: any, action: any) {


    this.selectedProductsList.forEach(element => {

      if (id == element.id) {

        switch (action) {
          case 'highlightToggle':
            element.highlighted = !element.highlighted;
            break;
          case 'highlighted_reportageToggle':
            element.highlighted_reportage = !element.highlighted_reportage;
            break;
          case 'downloadToggle':
            element.downloadable = !element.downloadable;
            break;
          case 'delete':
            let newList = []
            this.selectedProductsList.forEach(element => {
              if (element.id != id) {
                newList.push(element)
              }
            })

            this.productsList.forEach(element => {
              if (element.id == id) {
                delete element['selected']

                this.defaultPriceList.forEach(prices => {
                  if (prices.id == id) {
                    element['value'] = prices.value
                  }
                })

                element['min'] = 0;
                element['max'] = 0;
                element['highlighted'] = false;
                element['highlighted_reportage'] = false;
                element['downloadable'] = false;
              }
            });

            this.selectedProductsList = newList

            break;
          default:
            break;
        }

      }

    });
  }



  updateMin(product_ID: string, event : any){
    this.selectedProductsList.forEach(element => {

        if (element.id == product_ID) {

          element.min = event.target.value

        }

      });
  }

  updateMax(product_ID: string, event : any){
    this.selectedProductsList.forEach(element => {

        if (element.id == product_ID) {

          element.max = event.target.value

        }

      });
  }

  editProductValue(id: any, action: any, current_val: any = false) {

    action == 'open' ? this.editValueState.id = id : this.editValueState.id = ''


    if (action == 'open') {
      this.editValueState.id = id;

      this.productValueForm = this.formBuilder.group({

        value: new FormControl(current_val, Validators.required)

      })
    } else {

      if (!current_val.valid) throw new Error('This field cannot be empty')

      this.editValueState.id = ''

      this.selectedProductsList.forEach(element => {

        if (element.id == id) {

          element.value = current_val.value.value

        }

      });


      this.productValueForm = this.formBuilder.group({
        value: new FormControl('', Validators.required)
      })
    }


  }


  deleteCatalogue(catalogue_ID: any) {

    // We use ID to know which one to "delete"
    let params = { catalogue_id: catalogue_ID }

    // We create content for the confirm action popup
    let popup_content = {}

    this.translate.get('alerts.atention').subscribe(res => {
      popup_content['title'] = res;
    })

    this.translate.get('alerts.confirm_product_delete').subscribe(res => {
      popup_content['message'] = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      popup_content['ok_txt'] = res;
    })

    // We throw a confirm action popup
    let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
      data: {
        title: popup_content['title'],
        message: popup_content['message'],
        ok_txt: popup_content['ok_txt'],
        showSchools: catalogue_ID
      }
    }).beforeClosed().subscribe(res => {

      if (res) {

        // Call backend to change param of deleted to "true"
        this.dataService.deleteCatalogue(params).subscribe(data => {

          // If succesfull
          if (data.status == "success") {

            this.showCatalogsProgressBar = true;

            // We reload the products displayed in the table
            this.dataService.getCatalogs().subscribe(catalogs => {
              this.catalogs = catalogs;
              this.dataSource.data = this.catalogs;
              this.showCatalogsProgressBar = false
            });

          }

        })


      }


    })

  }

}
